import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/frontend/app/(homepage)/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/app/frontend/styles/cursor.css");
